import { render, staticRenderFns } from "./Sales.vue?vue&type=template&id=5372cedc&scoped=true&lang=pug&"
import script from "./Sales.vue?vue&type=script&lang=ts&"
export * from "./Sales.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5372cedc",
  null
  
)

export default component.exports